import * as React from "react";
import * as Moment from 'moment';
import { inputClasses } from '../validation/ValidationClasses';
import { FieldState, FieldApi } from "informed";

interface DatePickerProps {
    id: string;
    label: string;
    fieldState: FieldState<string>;
    fieldApi: FieldApi<string>;
    setValue: (value: string) => void;
    className: string;
    disabled?: boolean;
    required: boolean;
    acceptDateRange?: DatePickerAcceptDateRange;
    onBlur?: (value: string) => void;
    includeTime?: boolean;
    placeholder?: boolean;
}

export enum DatePickerAcceptDateRange {
    All,
    PastOrPresent,
}

export const DatePicker = ({ id, label, fieldState, fieldApi, setValue, className, onBlur, disabled, required, acceptDateRange, includeTime, placeholder }: DatePickerProps) => {
    const { value } = fieldState;

    const valueFormatted = includeTime ? value : placeholder ? null : Moment(value).format("YYYY-MM-DD");

    return <>
        <div className={className}>
            <label htmlFor={id}>{label}</label>
            <DatePickerNoForm
                value={valueFormatted}
                className={inputClasses(fieldApi.getError())}
                disabled={disabled}
                placeholder={placeholder}
                required={required}
                onChange={setValue}
                onBlur={onBlur}
                includeTime={includeTime}
                acceptDateRangeOptions={acceptDateRange}
            />
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError()}</span> : null}
        </div>
    </>
}

const formatString = (acceptDateTime?: boolean) => {
    if (acceptDateTime)
        return "YYYY-MM-DD HH:mm:ss";

    return "YYYY-MM-DD";
}

const maxDate = (acceptDateRange: DatePickerAcceptDateRange, acceptDateTime?: boolean): string => {
    if (acceptDateRange === DatePickerAcceptDateRange.PastOrPresent)
        return Moment(new Date()).format(formatString(acceptDateTime));

    return Moment(new Date("9999-12-31")).format(formatString(acceptDateTime));
}

export const DatePickerNoForm = ({ value, className, onChange, onBlur = null, placeholder, disabled = false, required = false, from = true, acceptDateRangeOptions = DatePickerAcceptDateRange.All, includeTime = false }) => {
    const placeholderText = placeholder ? "dd/mm/yyyy" : null;
    return (
        <input
            value={value}
            type={includeTime === true ? "datetime-local" : "date"}
            max={maxDate(acceptDateRangeOptions, includeTime)}
            className={className}
            placeholder={placeholderText}
            onChange={(e) => {
                if (onChange)
                    onChange(e.target.value ? Moment(e.target.value).format(formatString(includeTime)) : "")
            }}
            onBlur={(e) => {
                if (onBlur) {
                    onBlur(e.target.value ? Moment(e.target.value).format(formatString(includeTime)) : "")
                }
            }}
            disabled={disabled}
            required={required}
            data-automationid={(from ? "from" : "to") + "-date"}
        />
    );
}
